module.exports = __webpack_public_path__ + "img/questions.08324f97.svg";